import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";


// services
import {AuthService} from "../../../shared/services/auth.service";
import {TasksService} from "../../../shared/services/tasks.service";

// models
import {Task} from "../../../shared/models/tasks/task";

// modals
import {TaskCompletedModalComponent} from "../task-completed-modal/task-completed-modal.component";
import {TaskStatusModalComponent} from "../task-status-modal/task-status-modal.component";


@Component({
    selector: 'app-task-show',
    templateUrl: './task-show.component.html',
    styleUrl: './task-show.component.scss'
})
export class TaskShowComponent implements OnInit {

    public isLoading = false;
    public taskID = 0;
    public task!: Task;

    constructor(protected authService: AuthService,
                private tasksService: TasksService,
                private route: ActivatedRoute,
                private router: Router,
                private dialog: MatDialog) {
    }

    ngOnInit(): void {
        this.taskID = Number(this.route.snapshot.paramMap.get('id'));
        this.getCarData(this.taskID);
    }

    public editTask(): void {
        this.router.navigateByUrl(`secure/task-update/${this.taskID}`).then();
    }

    public changeTaskStatus(taskID: number, taskPriority: string, taskStatus: string): void {
        this.dialog.open(TaskStatusModalComponent, {
            data: {
                taskID: taskID,
                taskPriority: taskPriority,
                taskStatus: taskStatus
            }
        }).afterClosed().subscribe(
            (res): void => {
                if (!res) {
                    this.getCarData(this.taskID);
                }
            }
        );
    }

    public completed(): void {
        this.dialog.open(TaskCompletedModalComponent, {
            data: {
                taskID: this.taskID
            }
        }).afterClosed().subscribe(
            (res): void => {
                if (!res) {
                    this.router.navigateByUrl(`/secure/tasks`).then();
                }
            }
        );
    }

    public back(): void {
        if (this.task.completed) {
            this.router.navigateByUrl(`/secure/tasks-archive`).then();
        } else this.router.navigateByUrl(`/secure/tasks`).then();
    }

    private getCarData(id: number): void {
        this.isLoading = true;
        const userType = this.authService.user.type;
        this.tasksService.getTask(userType, id).subscribe((car: Task): void => {
            this.task = car;
            this.isLoading = false;
        })
    }
}
